"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { createClient } from "@/lib/supabase/client";
import { useAuthModal } from "@/components/auth/auth-modal-context";

export function UserMenu() {
  const { openAuthModal } = useAuthModal();
  const [email, setEmail] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    const supabase = createClient();

    supabase.auth.getUser().then(({ data }) => setEmail(data.user?.email ?? null));

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setEmail(session?.user?.email ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  async function handleSignOut() {
    const supabase = createClient();
    await supabase.auth.signOut();
  }

  if (email === undefined) {
    return <div className="h-8 w-20 shrink-0" />;
  }

  if (!email) {
    return (
      <Button variant="outline" size="sm" onClick={() => openAuthModal()}>
        Anmelden
      </Button>
    );
  }

  return (
    <div className="flex shrink-0 items-center gap-2">
      {/* "Dashboard"-Link entfernt (Nutzer-Feedback 2026-07-18): zeigte inhaltsgleich zu den
          bereits vorhandenen "Mein Depot"/"Watchlist"-Nav-Punkten (beide -> /dashboard mit
          Tab-Parameter) - redundanter dritter Weg zur selben Seite. Nutzername steht dadurch
          jetzt direkt neben "Abmelden", wie gewuenscht. */}
      <span className="hidden text-xs text-muted-foreground sm:inline">{email}</span>
      <Button variant="ghost" size="sm" onClick={handleSignOut}>
        Abmelden
      </Button>
    </div>
  );
}
